module.exports = __webpack_public_path__ + "img/building.b286e809.svg";